import React from "react";
import { FastField, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "../../../components/Input/AppInput";
import { Box, FormGroup, InputAdornment } from "@material-ui/core";
import { Mail } from "@material-ui/icons";
import AppButton from "components/CustomButtons/AppButton";
import AppConfig from "config/AppConfig";
const { PATTERNS } = AppConfig;

const ForgotPasswordForm = (props) => {
  const {
    onSubmit,
    loading
  } = props;
  const { t } = useTranslation();
  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        email: ''
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().trim()
        .required('validation.email.required')
        .email('validation.email.invalid')
        .max(255, { message: 'validation.max_length', value: 255})
        .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces')
      })}
    >
      {({ handleSubmit }) => {
        return (
          <Form>
            <FastField
              component={AppInput}
              name="email"
              id="email"
              label={t("label.email")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Mail />
                  </InputAdornment>
                ),
                onKeyDown: (event) => event.key === "Enter" && handleSubmit(),
              }}
            />
            <FormGroup>
              <Box display="flex" justifyContent="flex-end">
                <AppButton
                  onClick={handleSubmit}
                  label={t('label.reset')}
                  type="submit"
                  isLoading={loading}
                  disabled={loading}
                  fullWidth
                />
              </Box>
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool
};

export default ForgotPasswordForm;
